import React from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { TableSortLabel } from '@material-ui/core';
import GroupTablePagination from '../../components/atoms/GroupTablePagination';

const styles = {
  scrollTable: {
    // maxHeight: 400,
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    marginTop: 20
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(
  ({
    classes,
    shopGochiAmounts,
    page,
    rowsPerPage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleChangePage,
    handleRequestSort
  }) => {
    const shopGochiAmountList = shopGochiAmounts.list;
    return (
      <React.Fragment>
        <Typography component="h2" variant="h5" color="textSecondary">
          店舗別売上一覧
        </Typography>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sortDirection={orderBy === 'shopName' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'shopName'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('shopName');
                    }}
                  >
                    店舗名
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'buyGochiAmount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'buyGochiAmount'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('buyGochiAmount');
                    }}
                  >
                    売上額
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'buyGochiCount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'buyGochiCount'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('buyGochiCount');
                    }}
                  >
                    ごち数
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'useGochiAmount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'useGochiAmount'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('useGochiAmount');
                    }}
                  >
                    ごち利用額
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'useGochiCount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'useGochiCount'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('useGochiCount');
                    }}
                  >
                    ごちられ数
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shopGochiAmountList.map(shopGochiAmount => {
                const key = shopGochiAmount.shopId;
                return (
                  <TableRow key={key} hover>
                    <TableCell>{shopGochiAmount.shopName}</TableCell>
                    <TableCell>
                      {shopGochiAmount.buyGochiAmount
                        ? shopGochiAmount.buyGochiAmount.toLocaleString()
                        : 0}
                    </TableCell>
                    <TableCell>
                      {shopGochiAmount.buyGochiCount
                        ? shopGochiAmount.buyGochiCount.toLocaleString()
                        : 0}
                    </TableCell>
                    <TableCell>
                      {shopGochiAmount.useGochiAmount
                        ? shopGochiAmount.useGochiAmount.toLocaleString()
                        : 0}
                    </TableCell>
                    <TableCell>
                      {shopGochiAmount.useGochiCount
                        ? shopGochiAmount.useGochiCount.toLocaleString()
                        : 0}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        <div>
          <GroupTablePagination
            limit={rowsPerPage}
            setLimit={() => {}}
            handleChangePage={handleChangePage}
            totalCount={shopGochiAmounts.count}
            selectedPage={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            offset={shopGochiAmounts.offset}
          />
        </div>
      </React.Fragment>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
